export default {
    url: '/activate?token',
    cache: false,
    template: '<auth-activate token="vm.token" company-terms="vm.companyTerms"></auth-activate>',
    resolve: {
        terms (CompanyResource, $stateParams) {
            return CompanyResource.terms({ token: $stateParams.token }).$promise;
        }
    },
    controller ($state, $stateParams, terms) {
        if (terms.isAccountActivated) {
            $state.go('unauthorized.login', { company: $stateParams.company });
        }
        this.companyTerms = terms.terms; // because api returns array
        this.token = $stateParams.token;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/unauthorized/activate/index.js